import React, { useEffect, useState } from "react";
import axios from "axios";
import classes from "./checkout-form.module.scss";
import ButtonSpinner from "../../common/ButtonSpinner";

function CODConfirm({ Order, OrderPayment, confirm_order, clear_order }) {
  const [countdown, setCountdown] = useState(1);
  const [OTP, setOPT] = useState("");
  const [OTPError, setOTPError] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [resending, setResending] = useState(false);
  const [resentSuccess, setResentSuccess] = useState(false);

  useEffect(() => {
    setCountdown(OrderPayment.otp.server_resend_step);
    const timer = setInterval(() => {
      setCountdown((c) => (c == 0 ? 0 : c - 1));
    }, OrderPayment.otp.server_resend_rate);
    return () => {
      return clearInterval(timer);
    };
  }, []);

  if (!Order || !OrderPayment) return null;

  const handleResend = () => {
    setResending(true);
    setResentSuccess(false);
    setOPT("");
    setOTPError(null);
    axios
      .post(
        `${global.postUrl}refine/order_resend_cod_otp`,
        {
          message: {
            order_id: Order.order_id,
            vo_id: Order.vo_id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: null,
          },
        },
      )
      .then(
        (response) => {
          const data = response.data;
          setResending(false);
          if (data && data.session) {
            localStorage.setItem("sd_session", data.session);
          }
          if (data.message.action) {
            setResentSuccess(true);
            setCountdown(OrderPayment.otp.server_resend_step);
          }
        },
        () => {
          setResending(false);
        },
      );
  };

  const handleConfirm = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (OTP.length == 4) {
      setOTPError(false);
      setConfirming(true);
      confirm_order({ otp: OTP, forceCOD: true }, (errorData) => {
        setConfirming(false);
        const reason = errorData && errorData.reason;
        const msg =
          reason === "OTP_MISSMATCH" || reason === "INVALID_OTP"
            ? "Incorrect OTP. Please try again."
            : "Please try again later.";
        setOTPError(msg);
      });
    } else {
      setOTPError("Please enter a valid 4 digit one time password.");
    }
  };

  return (
    <div className={classes.otpOverlay}>
      <div className={classes.otpCard}>
        <div className={classes.otpHeader}>
          <h4 className={classes.otpTitle}>Verify Your Mobile Number</h4>
          <button
            type="button"
            className={classes.otpClose}
            onClick={() => clear_order()}
            aria-label="Close"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M1 1l12 12M13 1L1 13" />
            </svg>
          </button>
        </div>

        <form className={classes.otpBody} onSubmit={handleConfirm}>
          <div className={classes.otpIconWrap}>
            <svg
              viewBox="0 0 16 16"
              fill="#722257"
              width="56"
              height="56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
            </svg>
          </div>

          {OrderPayment.otp.success && (
            <p className={classes.otpDesc}>
              Please verify yourself using the One Time Password that has been
              sent to <strong>+91{Order.phone}</strong> and proceed with your
              order.
            </p>
          )}

          {!OrderPayment.otp.success && (
            <div className={classes.otpWarning}>
              <strong>Oops!</strong> Please wait {countdown} seconds before
              requesting a new one time password.
            </div>
          )}

          <div className={classes.otpInputGroup}>
            <label className={classes.otpLabel} htmlFor="cod-otp">
              One Time Password
            </label>
            <input
              id="cod-otp"
              name="otp"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className={`${classes.otpInput} ${
                OTPError ? classes.otpInputError : ""
              }`}
              value={OTP}
              maxLength={4}
              placeholder="----"
              autoFocus
              onChange={(e) => {
                setOPT(e.target.value.replace(/\D/g, "").slice(0, 4));
                if (OTPError) setOTPError(null);
              }}
            />
            {OTPError && (
              <div className={classes.otpFieldError}>{OTPError}</div>
            )}
          </div>

          <div className={classes.otpResend}>
            {resentSuccess && (
              <span className={classes.otpResentBadge}>
                OTP resent successfully!
              </span>
            )}
            {countdown == 0 ? (
              <button
                type="button"
                className={`${classes.otpResendLink} ${
                  resending ? classes.otpResendLinkDisabled : ""
                }`}
                disabled={resending}
                onClick={!resending ? handleResend : undefined}
              >
                {resending ? "Sending..." : "Request another OTP"}
              </button>
            ) : (
              <span>
                Resend a new OTP in <strong>{countdown}</strong> Seconds
              </span>
            )}
          </div>

          <button
            type="submit"
            className={classes.otpConfirmBtn}
            disabled={confirming}
          >
            {confirming ? <ButtonSpinner /> : "Confirm and Place Order"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CODConfirm;
